import React, { useState } from 'react';
import { Typography, Button } from '../../components';
import {
    Container,
    Introduction,
    IntroductionText,
    Steps,
    Step,
    StepNumber,
    StepContent,
    CTA,
    FormSection,
    Form,
    FormGroup,
    Label,
    Input,
    Textarea,
    Required,
    Optional,
    RadioGroup,
    RadioOption,
    Confirmation,
    ParentNotice,
    ContactLink,
    ErrorMessage,
} from './styled';
import axiosInstance from '../../actions/axios';

export default function Aanmelden() {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [startFrom, setStartFrom] = useState('');
    const [organisation, setOrganisation] = useState('');
    const [location, setLocation] = useState('');
    const [message, setMessage] = useState('');

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [sending, setSending] = useState(false);

    async function onSubmit(event) {
        event.preventDefault();

        setError('');
        setSending(true);

        let newPhoneNumber = phone;

        if (
            newPhoneNumber &&
            !newPhoneNumber.includes('+') &&
            newPhoneNumber[0] === '0'
        ) {
            newPhoneNumber = '+31' + newPhoneNumber.substring(1);
        }

        const formValues = {
            sender_category: 'NOLIA-aanmelding',
            sender_first_name: name,
            sender_last_name: '',
            sender_phone_number: newPhoneNumber,
            sender_email: email,
            sender_practice: organisation,

            // Tijdelijk gebruiken we het bestaande veld
            // om de nieuwe ontvanger mee te geven.
            consultant_name: '',
            consultant_company_name: '',
            consultant_email: 'support@babyfeeding.nl',

            wants_register: true,
            wants_workshop_name: '',
            wants_dates: false,
            wants_info: false,

            info_wanted: message,
        };

        try {
            const res = await axiosInstance.post(
                '/register-email/',
                { ...formValues }
            );

            if (res.status === 200) {
                setSubmitted(true);
            } else {
                setError(
                    'Er is iets misgegaan. Neem rechtstreeks contact met ons op via info@babyfeeding.nl.'
                );
            }
        } catch (error) {
            console.log(error);

            setError(
                'Er is iets misgegaan. Neem rechtstreeks contact met ons op via info@babyfeeding.nl.'
            );
        } finally {
            setSending(false);
        }
    }

    if (submitted) {
        return (
            <Container>
                <Confirmation>
                    <Typography type='h1'>
                        Gelukt! Je aanmelding is bij ons binnen.
                    </Typography>

                    <Typography>
                        Leuk dat je met NOLIA aan de slag wilt. We nemen
                        contact met je op om kennis te maken en samen te kijken
                        naar jouw of jullie situatie, wensen en mogelijkheden.
                    </Typography>

                    <Typography>
                        Je hoeft nu niets meer te doen. We pakken het vanaf
                        hier samen verder op.
                    </Typography>
                </Confirmation>
            </Container>
        );
    }

    return (
        <Container>

            {/* INTRODUCTIE */}

            <Introduction>
                <IntroductionText>

                    <Typography type='caps'>
                        NOLIA BabyFeeding
                    </Typography>

                    <Typography type='h1'>
                        Starten met NOLIA BabyFeeding?
                    </Typography>

                    <Typography type='h2'>
                        Samen kijken naar wat past bij jou of jullie organisatie.
                    </Typography>

                    <Typography>
                        Wil je NOLIA aanbieden als zelfstandig professional of
                        binnen jullie organisatie? Dan ben je hier op de juiste
                        plek.
                    </Typography>

                    <Typography>
                        Meld je aan en laat kort je gegevens achter. Daarna
                        nemen we contact met je op en kijken we samen naar jullie
                        situatie, wensen en mogelijkheden om met NOLIA te starten.
                    </Typography>

                    <Button
                        text='Start je aanmelding'
                        href='#aanmeldformulier'
                        buttonstyle='primary'
                        style={{ marginTop: '1em' }}
                    />

                    <Typography
                        style={{
                            fontSize: '0.9em',
                            marginTop: '1em',
                            opacity: 0.75
                        }}
                    >
                        Aanmelden is nog geen definitieve overeenkomst. We kijken
                        eerst samen wat bij jou of jullie organisatie past.
                    </Typography>

                </IntroductionText>
            </Introduction>


            {/* STAPPEN */}

            <Steps>

                <Typography type='h2'>
                    Wat gebeurt er na je aanmelding?
                </Typography>

                <Step>
                    <StepNumber>1</StepNumber>

                    <StepContent>
                        <Typography type='h3'>
                            Je meldt je aan
                        </Typography>

                        <Typography>
                            Laat je gegevens achter, zodat we weten wie je bent
                            en van waaruit je met NOLIA wilt starten.
                        </Typography>
                    </StepContent>
                </Step>

                <Step>
                    <StepNumber>2</StepNumber>

                    <StepContent>
                        <Typography type='h3'>
                            We bespreken de mogelijkheden
                        </Typography>

                        <Typography>
                            We nemen contact met je op en kijken samen naar je
                            situatie, wensen en wat er nodig is om NOLIA goed
                            te kunnen starten.
                        </Typography>
                    </StepContent>
                </Step>

                <Step>
                    <StepNumber>3</StepNumber>

                    <StepContent>
                        <Typography type='h3'>
                            We bepalen samen de volgende stap
                        </Typography>

                        <Typography>
                            Past NOLIA bij wat jij of jullie organisatie zoekt?
                            Dan maken we samen een passende route richting de
                            opstart.
                        </Typography>
                    </StepContent>
                </Step>

            </Steps>


            {/* CTA */}

            <CTA>

                <Typography type='h2'>
                    Klaar voor de volgende stap?
                </Typography>

                <Typography>
                    Leuk! Laat je gegevens achter. Dan nemen we van daaruit
                    samen de volgende stap.
                </Typography>

                <Button
                    text='Start je aanmelding'
                    href='#aanmeldformulier'
                    buttonstyle='primary'
                    style={{ marginTop: '1em' }}
                />

                <Typography style={{ marginTop: '1.5em' }}>
                    Nog aan het oriënteren en wil je eerst even overleggen?
                    Neem dan <ContactLink href='/contact'>contact met ons op</ContactLink>.
                </Typography>

                <ParentNotice>
                    <Typography>
                        Ben je (aanstaande) ouder en wil je deelnemen aan NOLIA?
                        Dan hoef je je hier niet aan te melden. Bekijk het
                        NOLIA-aanbod bij jou in de buurt via deze{' '}
                        <ContactLink href='/locaties'>
                            websitelink
                        </ContactLink>.
                    </Typography>
                </ParentNotice>

            </CTA>


            {/* FORMULIER */}

            <FormSection id='aanmeldformulier'>

                <Typography type='h2'>
                    Aanmeldformulier
                </Typography>

                <Typography>
                    Leuk dat je met NOLIA aan de slag wilt!
                </Typography>

                <Typography>
                    Vertel ons kort wie je bent. Je hoeft nog niet precies te
                    weten hoe je NOLIA wilt gaan organiseren — daar kijken we
                    samen naar.
                </Typography>


                <Form onSubmit={onSubmit}>

                    <FormGroup>
                        <Label htmlFor='name'>
                            Naam <Required>*</Required>
                        </Label>

                        <Input
                            id='name'
                            type='text'
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            required
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label htmlFor='email'>
                            E-mailadres <Required>*</Required>
                        </Label>

                        <Input
                            id='email'
                            type='email'
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            required
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label htmlFor='phone'>
                            Telefoonnummer <Optional>(optioneel)</Optional>
                        </Label>

                        <Input
                            id='phone'
                            type='tel'
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)}
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label>
                            Ik wil NOLIA starten… <Required>*</Required>
                        </Label>

                        <RadioGroup>

                            <RadioOption>
                                <input
                                    type='radio'
                                    name='startFrom'
                                    value='als zelfstandig professional'
                                    checked={
                                        startFrom ===
                                        'als zelfstandig professional'
                                    }
                                    onChange={(event) =>
                                        setStartFrom(event.target.value)
                                    }
                                    required
                                />

                                <span>
                                    als zelfstandig professional
                                </span>
                            </RadioOption>

                            <RadioOption>
                                <input
                                    type='radio'
                                    name='startFrom'
                                    value='vanuit een organisatie'
                                    checked={
                                        startFrom ===
                                        'vanuit een organisatie'
                                    }
                                    onChange={(event) =>
                                        setStartFrom(event.target.value)
                                    }
                                />

                                <span>
                                    vanuit een organisatie
                                </span>
                            </RadioOption>

                        </RadioGroup>
                    </FormGroup>


                    <FormGroup>
                        <Label htmlFor='organisation'>
                            Organisatie/praktijk
                        </Label>

                        <Input
                            id='organisation'
                            type='text'
                            value={organisation}
                            onChange={(event) =>
                                setOrganisation(event.target.value)
                            }
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label htmlFor='location'>
                            Plaats/regio <Required>*</Required>
                        </Label>

                        <Input
                            id='location'
                            type='text'
                            value={location}
                            onChange={(event) =>
                                setLocation(event.target.value)
                            }
                            required
                        />
                    </FormGroup>


                    <FormGroup>
                        <Label htmlFor='message'>
                            Wil je ons alvast iets meegeven?{' '}
                            <Optional>(optioneel)</Optional>
                        </Label>

                        <Textarea
                            id='message'
                            value={message}
                            onChange={(event) =>
                                setMessage(event.target.value)
                            }
                            placeholder='Bijvoorbeeld een vraag, jullie huidige situatie of iets waarover je graag wilt sparren.'
                        />
                    </FormGroup>


                    {error && (
                        <ErrorMessage>
                            {error}
                        </ErrorMessage>
                    )}


                    <Button
                        type='submit'
                        buttonstyle='primary'
                        text={
                            sending
                                ? 'Versturen...'
                                : 'Aanmelding versturen'
                        }
                        disabled={sending}
                        style={{ marginTop: '0.5em' }}
                    />

                </Form>

            </FormSection>

        </Container>
    );
}